import STATUS from '../../../globalStatuses';
import { ACTIONS } from './types';

export const initialState = {
  requestKey: null,
  requestId: null,
  status: STATUS.UNFETCHED,
  results: null,
  error: null,
};

// eslint-disable-next-line default-param-last
export default function stackableSavings(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.REQUEST_STACKABLE_SAVINGS:
      return {
        ...initialState,
        requestKey: action.requestKey,
        requestId: action.requestId,
        status: STATUS.FETCHING,
      };
    case ACTIONS.RECEIVE_STACKABLE_SAVINGS:
    case ACTIONS.REQUEST_STACKABLE_SAVINGS_ERROR:
      if (state.requestKey !== action.requestKey
        || state.requestId !== action.requestId) return state;
      return {
        ...state,
        status: action.type === ACTIONS.RECEIVE_STACKABLE_SAVINGS ? STATUS.FETCHED : STATUS.ERROR,
        results: action.results || null,
        error: action.error || null,
      };
    default:
      return state;
  }
}
